// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Chairman',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [],
      pageIdList: [346,345,347,349,348],
      // data
      swiperSlides: '',
      pageInfo: '',
      factoryList: [],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        effect : 'slide',
        loop : true,
        autoplay : {
          delay: 3000,
          disableOnInteraction: false,
        },
      },
      galleryParams: [
        {
          param: {
            factoryName: 'EVN'
          },
          query: {
            sid: 24,
          },
        },
        {
          param: {
            factoryName: 'EVH'
          },
          query: {
            sid: 33,
          },
        },
        {
          param: {
            factoryName: 'EVM'
          },
          query: {
            sid: 42,
          },
        },
        {
          param: {
            factoryName: 'EVC'
          },
          query: {
            sid: 51,
          },
        },
        {
          param: {
            factoryName: 'PRB'
          },
          query: {
            sid: 60,
          },
        },
        {
          param: {
            factoryName: 'PBB'
          },
          query: {
            sid: 69,
          },
        },
      ],
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getAdPictureList();
      this.getPageInfo();
      this.getFactoryList();
    },
    // 根据id获取页面内容
    getPageInfo() {
      const param = {
        id: this.pageIdList[this.LangIndex],
      };
      ModelService.getPageInfo(param).then((res) => {
        if (res.code === 0) {
          this.pageInfo = res.data;
        }
      });
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data;
        }
      });
    },
    // 获取工厂列表
    getFactoryList() {
      const language = {
        lang: this.language
      };
      ModelService.getFactoryList(language).then((res) => {
        if (res.code === 0) {
          this.factoryList = res.data;
          // console.log('getFactoryList: ', res.data);
        }
      });
    },
    // 数据过滤
    even(numbers, target) {
      return numbers.filter( (number) => {
        return number.param.factoryName === target
      })
    },
    // 跳转对应相册
    goGalleryPage(name) {
      const urls = this.even(this.galleryParams, name)[0];
      this.$tools.go({
        name: 'Gallery',
        params: urls.param,
        query: urls.query,
      });
    },
  },
};
